import { MapPin, Check, Phone } from "lucide-react";
import { SITE } from "@/lib/siteConfig";

export default function Zones() {
  return (
    <section id="zones" data-testid="zones-section" className="bg-white py-20 sm:py-28 reveal">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-6">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-red-600 mb-4">
              — Zone d'intervention
            </div>
            <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl uppercase leading-[0.95]">
              Serrurier<br /><span className="text-red-600">près de chez vous.</span>
            </h2>
            <p className="mt-5 text-lg text-slate-600 max-w-md leading-relaxed">
              Nos équipes de serruriers professionnels interviennent
              en moins de 30 minutes, 24h/24 et 7j/7,
              avec matériel certifié A2P et devis transparent.
            </p>

            <a
              href={SITE.phoneHref}
              data-testid="zones-call"
              className="mt-8 inline-flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white px-6 py-4 font-display font-bold uppercase tracking-tight transition-all shadow-[0_4px_0_#991B1B] hover:shadow-[0_2px_0_#991B1B] hover:-translate-y-0.5"
            >
              <Phone className="w-5 h-5" strokeWidth={2.5} />
              Appeler {SITE.phone}
            </a>
          </div>

          <div className="lg:col-span-6">
            <div className="relative bg-[#0A0A0A] text-white p-8 sm:p-10 border-l-4 border-red-600 overflow-hidden">
              <div className="absolute top-0 right-0 bg-red-600 text-white px-4 py-2 text-[10px] uppercase tracking-[0.2em] font-bold">
                Intervention rapide
              </div>

              <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-red-400 mb-3 mt-3">
                Nous intervenons
              </div>
              <div className="flex items-center gap-3">
                <Check className="w-7 h-7 text-red-500 flex-shrink-0" strokeWidth={3} />
                <span className="font-display font-black text-3xl sm:text-4xl uppercase tracking-tighter">
                  Près de chez vous
                </span>
              </div>

              <div className="mt-6 grid grid-cols-2 gap-px bg-white/10">
                <div className="bg-[#0A0A0A] p-4">
                  <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-bold">Statut</div>
                  <div className="mt-1 inline-flex items-center gap-2 font-display font-bold">
                    <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
                    En ligne
                  </div>
                </div>
                <div className="bg-[#0A0A0A] p-4">
                  <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-bold">Délai</div>
                  <div className="mt-1 font-display font-bold">{"<"} 30 min</div>
                </div>
              </div>

              <div className="mt-6 flex items-start gap-2 text-sm text-slate-400">
                <MapPin className="w-4 h-4 mt-0.5 text-red-400 flex-shrink-0" />
                <span>
                  Appelez-nous pour vérifier la disponibilité immédiate sur votre adresse.
                  Nos équipes sont mobiles et interviennent rapidement.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
